import { Pipe, PipeTransform } from "@angular/core";
import { FormatHelper } from "app/shared/utils/format-helper";

@Pipe({ name: "FormatCurrency" })
export class FormatCurrency implements PipeTransform {
    transform(value: any, currencyCode: string, language: string = navigator.language, currencyClassification: string): string {
        return FormatHelper.currency(value, currencyCode, language, currencyClassification);
    }
}
